import { useAPIRequest } from "@certn/legacy-api";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { useParams } from "react-router-dom";

export function usePhotoUpload() {
  const { applicantId } = useParams();
  const request = useAPIRequest();

  return async (imageUri: string) => {
    const response = await request<
      components["schemas"]["DocumentCreateResponse"]
    >(`/internal/people/applicant/${applicantId}/document/create`, {
      method: "POST",
      body: JSON.stringify({
        file_name: "selfie.jpg",
        file_type: "image/jpg",
        document_type: "SELFIE",
      }),
    });

    const body = new FormData();

    Object.entries(response.fields).forEach(([key, value]) =>
      body.append(key, value as string)
    );

    const imageResponse = await fetch(imageUri);
    const imageBlob = await imageResponse.blob();

    body.append("file", imageBlob);

    await fetch(response.url, { method: "POST", body });

    return response.document_id;
  };
}
